/**
 * Browser stand-in for `node:fs`. jkurwa imports it only for its deprecated
 * `privPath` / `certPath` options, which this library never uses — keys always
 * arrive as buffers. Aliased by path from tools/vite/aliases.mjs.
 */
export const readFileSync = (): never => {
  throw new Error("fs is not available in the browser");
};

export default { readFileSync };
